export default "__VITE_ASSET__D7MB1Dli__"